module.exports = __webpack_public_path__ + "static/moonamar-konopljino-ulje-iz-organskog-bio-sjemena-da840dcca303002e7992c8a7f7d58976.png";